'use strict'

export default function () {
  $('.navbar-collapse').on('show.bs.collapse', function () {
    document.getElementsByTagName('body')[0].style.overflow = 'hidden'
  })
  $('.navbar-collapse').on('hide.bs.collapse', function () {
    document.getElementsByTagName('body')[0].style.overflow = 'auto'
  })
}
